import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { changeUserFilter } from '../actions';
import { Search } from '../../../components/Icon';

import styles from './SearchText.module.css';

const STATE = {
  search: '',
};
/* eslint-disable react/prefer-stateless-function */
class UserSearchTextComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      search: props.filter.searchString || '',
    });
  }

  componentDidMount() {}

  doSearch = () => {
    this.props.setSearchString(this.state.search);
  };

  searchStringChangeHandler() {
    this._t = this.timeout(
      () => {
        this.props.setSearchString(this.state.search);
      },
      600,
      this._t,
    );
  }

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.props.setSearchString(this.state.search);
    }
  };

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    return (
      <div className="d-flex">
        <input
          type="text"
          className={`form-control fw-light ${styles.Input}`}
          name="search"
          value={this.state.search}
          placeholder={this.lblStr('search')}
          onChange={evt => {
            this.setState({ search: evt.target.value });
          }}
          onKeyPress={this.handleKeyPress}
        />
        <button className={`btn btn-outline-secondary ${styles.Button}`} type="button" onClick={this.doSearch.bind(this)}>
          <Search />
        </button>
      </div>
    );
  }
}

UserSearchTextComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setSearchString(string) {
      dispatch(changeUserFilter('searchString', string));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserSearchText = compose(withConnect, withRouter, injectIntl)(UserSearchTextComp);
